<template>
  <a-config-provider :locale="zh_CN">
    <div id="app">
      <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
  </a-config-provider>
</template>
<script>
import zh_CN from "ant-design-vue/es/locale/zh_CN";
// import moment from 'moment'
// moment.locale('zh-cn');
// import zh_CN from 'moment/dist/locale/zh-cn';
import './assets/font/iconfont.css'
require('./assets/font/iconfont.js')
export default {
  data(){
    return {
      zh_CN,
    }
  },
  created(){
  }
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}
/* 滚动槽 */
::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}
::-webkit-scrollbar-track {
    border-radius: 3px;
    background: rgba(0,0,0,0.06);
    box-shadow: inset 0 0 5px rgba(0,0,0,0.08);
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background: rgba(0,0,0,0.12);
    box-shadow: inset 0 0 10px rgba(0,0,0,0.2);
}
nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.custom-button{
  background-color: #436be5 !important;
  border-color: #436be5 !important;
  color: #fff !important;

}
.ant-btn{
  margin-right: 15px;
}
.ant-tabs-bar{
  margin: 0px !important;
}
.children-popover{
  .ant-popover-content{
    .ant-checkbox-wrapper + .ant-checkbox-wrapper{
      margin-left: 0px !important;
    }
  }
   .ant-popover-content{
    width: 200px !important;
  }
  .ant-checkbox-wrapper + .ant-checkbox-wrapper{
    margin: 0px !important;
  }
}
.flex-form{
    .ant-row{
        display: flex;
    }
}
.ant-tabs{
  background-color: #fff;
}
.content{
  padding: 20px;
  overflow: auto;
  height: calc(100% - 40px);
  background-color: #fff;
}
.content-tail{
  height: calc(100% - 44px);
  padding: 20px;
  overflow: auto;
  background-color: #fff;
}
.content-tabs-tail{
  height: calc(100% - 84px);
  padding: 20px;
  overflow: auto;
  background-color: #fff;
}
.content-h100{
  height: 100%;
}
.tail{
    position: fixed;
    height: 40px;
    width: calc(100% - 260px);
    background-color: #e7eef7;
    border-radius: 5px;
    bottom: 20px;
    left: 240px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.inline-form{
  display:inline-block !important;
}
.modal-overflow{
  .ant-modal-content{
    .ant-modal-body{
      max-height: 600px !important;
      overflow:auto;

    }
  }
}
.form-model{
  .ant-row {
    display: flex !important;
  }
}

.new-form{
  .ant-input-disabled{
    border: 0px;
    border-bottom: 1px solid #b7b7b7;
    background-color: transparent !important;
    border-radius: 0px !important;
    color: black !important;
  }
}
.w350{
  width: 350px !important;
}
.w150{
  width: 150px !important;
}
//ant-input

// .ant-input{
//   height: 28px !important;
// }
.ant-select-selection--single{
  height: 28px ;
}


.ant-menu-dark .ant-menu-item-active, .ant-menu-dark .ant-menu-item:hover, .ant-menu-dark .ant-menu-submenu-active, .ant-menu-dark .ant-menu-submenu-open, .ant-menu-dark .ant-menu-submenu-selected, .ant-menu-dark .ant-menu-submenu-title:hover{
    color: #8aa8eb !important
}
// .ant-spin-nested-loading{
//   height: 100%;
//   .ant-spin-container{
//     height: 100%;
//   }
// }

.ant-table-fixed-header .ant-table-scroll .ant-table-header {
  overflow-y: hidden !important;
  // height: 70px;
}
.ant-table-body{
  overflow: auto !important;
}
.ant-spin-nested-loading{
  height: 100%;
}
.ant-spin-container{
  height: 100%;
}
p{
  font-family: 'arial' !important;
}
.tail-btn{
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1,;
}
</style>
